/* eslint-disable */
// GENERATED by scripts/gen-modules.js from saf3ai-auth-sdk/src/saf3ai_auth/catalog/modules.yaml
// Do not edit by hand: run `node scripts/gen-modules.js` after the SDK catalog changes.
//
// Fallback copy of GET /auth/api/v1/rbac/catalog (modules + module_groups only),
// used when that request fails. See src/licensing/moduleCatalog.js.

const MODULE_CATALOG = {
  "version": 2,
  "module_groups": [
    {
      "key": "modules",
      "label": "Modules",
      "order": 0
    },
    {
      "key": "platform",
      "label": "Platform",
      "order": 1
    },
    {
      "key": "sources",
      "label": "Data sources",
      "order": 2
    }
  ],
  "modules": [
    {
      "slug": "discovery",
      "label": "Discovery",
      "group": "modules",
      "description": "AI agents, users and identities, endpoints, cloud and the AI-BOM",
      "core": false,
      "aliases": [],
      "ui_sections": [
        "shadow-ai",
        "cloud-ai"
      ]
    },
    {
      "slug": "assessment",
      "label": "Assessment",
      "group": "modules",
      "description": "Findings, red teaming, model evaluation and code security",
      "core": false,
      "aliases": [
        "redteam",
        "red_teaming",
        "sast"
      ],
      "ui_sections": [
        "sast"
      ]
    },
    {
      "slug": "security",
      "label": "Security",
      "group": "modules",
      "description": "Threat summary, detections, incidents, hunting, skills and AI posture",
      "core": false,
      "aliases": [
        "deepfake"
      ],
      "ui_sections": [
        "security"
      ]
    },
    {
      "slug": "finops",
      "label": "FinOps & Adoption",
      "group": "modules",
      "description": "AI spend and ROI, budgets, and how people adopt AI",
      "core": false,
      "aliases": [],
      "ui_sections": [
        "finops"
      ]
    },
    {
      "slug": "governance",
      "label": "Governance",
      "group": "modules",
      "description": "Compliance frameworks, controls and the audit report",
      "core": false,
      "aliases": [
        "compliance"
      ],
      "ui_sections": []
    },
    {
      "slug": "atlas",
      "label": "Agent Atlas",
      "group": "platform",
      "description": "Home, Inbox, Log Explorer and Notifications across every source",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "agent-atlas"
      ]
    },
    {
      "slug": "policy",
      "label": "Policy & Guardrails",
      "group": "platform",
      "description": "Policy authoring and enforcement plane shared by every module",
      "core": true,
      "aliases": [
        "opa_policies"
      ],
      "ui_sections": [
        "governance"
      ]
    },
    {
      "slug": "saf3ai_chat",
      "label": "SAF3AI Assistant",
      "group": "platform",
      "description": "In-product assistant",
      "core": true,
      "aliases": [],
      "ui_sections": []
    },
    {
      "slug": "copilot",
      "label": "Microsoft 365 Copilot",
      "group": "sources",
      "description": "AI security monitoring for Microsoft 365 Copilot",
      "core": true,
      "aliases": [
        "microsoft_copilot"
      ],
      "ui_sections": [
        "enterprise-ai"
      ]
    },
    {
      "slug": "copilot_studio",
      "label": "Microsoft Copilot Studio",
      "group": "sources",
      "description": "Agents built in Copilot Studio",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "copilot-studio"
      ]
    },
    {
      "slug": "gemini",
      "label": "Gemini for Workspace",
      "group": "sources",
      "description": "AI security monitoring for Google Workspace Gemini",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "gemini-workspace"
      ]
    },
    {
      "slug": "gemini_enterprise",
      "label": "Gemini Enterprise",
      "group": "sources",
      "description": "Agents and usage in Google Gemini Enterprise",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "gemini-enterprise-agents"
      ]
    },
    {
      "slug": "openai",
      "label": "OpenAI",
      "group": "sources",
      "description": "ChatGPT Enterprise and OpenAI API usage",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "openai-platform",
        "saas-ai-platform"
      ]
    },
    {
      "slug": "anthropic",
      "label": "Anthropic",
      "group": "sources",
      "description": "Claude and Anthropic API usage",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "saas-ai-platform"
      ]
    },
    {
      "slug": "cursor",
      "label": "Cursor",
      "group": "sources",
      "description": "Cursor IDE usage",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "saas-ai-platform"
      ]
    },
    {
      "slug": "google_antigravity",
      "label": "Google Antigravity",
      "group": "sources",
      "description": "Google Antigravity usage",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "saas-ai-platform"
      ]
    },
    {
      "slug": "endpoint",
      "label": "Endpoint Security",
      "group": "sources",
      "description": "Browser extension and Endpoint Security sensor",
      "core": true,
      "aliases": [
        "shadow_ai"
      ],
      "ui_sections": [
        "endpoint-management"
      ]
    },
    {
      "slug": "ai_gateway",
      "label": "AI Gateway",
      "group": "sources",
      "description": "Inline AI gateway and SWG feeds",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "ai-gateway"
      ]
    },
    {
      "slug": "mdm",
      "label": "MDM",
      "group": "sources",
      "description": "Jamf and Intune shadow-AI inventory",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "mdm"
      ]
    },
    {
      "slug": "edr",
      "label": "EDR",
      "group": "sources",
      "description": "CrowdStrike and Defender AI telemetry",
      "core": true,
      "aliases": [],
      "ui_sections": [
        "edr"
      ]
    },
    {
      "slug": "cloud_discovery",
      "label": "Cloud AI",
      "group": "sources",
      "description": "AI services across GCP, AWS and Azure",
      "core": true,
      "aliases": [
        "vertex_ai",
        "azure_openai",
        "aws_bedrock"
      ],
      "ui_sections": []
    },
    {
      "slug": "monitoring",
      "label": "Custom Agents",
      "group": "sources",
      "description": "Observability, logs and anomaly detection for your own agents",
      "core": true,
      "aliases": [
        "log_tracer",
        "custom_agents"
      ],
      "ui_sections": [
        "custom-agents",
        "monitoring",
        "model-selection",
        "custom-dashboards"
      ]
    }
  ]
};

export default MODULE_CATALOG;
